export default {
	messages: {
		de: {
			phone: 'Telefon',
			mobile: 'Mobil',
			email: 'Email',

			noData: 'Keine Daten',
		},
		en: {
			phone: 'Phone',
			mobile: 'Mobile',
			email: 'Email',

			noData: 'No data',
		},
	},
};
